import { render, staticRenderFns } from "./dataStatistical.vue?vue&type=template&id=2b31c826&scoped=true&"
import script from "./dataStatistical.vue?vue&type=script&lang=js&"
export * from "./dataStatistical.vue?vue&type=script&lang=js&"
import style0 from "./dataStatistical.vue?vue&type=style&index=0&id=2b31c826&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b31c826",
  null
  
)

export default component.exports